import V5Placeholder from './views/V5Placeholder.vue';
import V5ShellRoute from './shell/V5ShellRoute.vue';
import { V5_PAGES, v5Path } from './nav';

// Each rebuilt page lives in src/v5/pages/<Name>/ with a route.js exporting its route or routes,
// so adding a page never edits this file. Sidebar pages without one get a placeholder that links
// to the classic page. V5Layout sends anyone outside the audience back to the classic app.
// Pages render inside one parent route that holds the shell, so navigating keeps it mounted;
// meta.bare pages (log in, sign up, onboarding) are full screen and sit outside it.
const built = Object.values(import.meta.glob('./pages/*/route.js', { eager: true, import: 'default' }))
  .flat()
  .map((r) => ({ ...r, meta: { ...r.meta, auth: true } }));
const builtPaths = new Set(built.map((r) => r.path));

const placeholders = V5_PAGES.filter((p) => !builtPaths.has(v5Path(p.key))).map((p) => ({
  path: v5Path(p.key),
  name: `V5_${p.key}`,
  component: V5Placeholder,
  props: { page: p.key },
  meta: { auth: true, placeholder: true },
}));

// eslint-disable-next-line import-x/prefer-default-export
export const v5Routes = [
  {
    // Children keep their absolute /v5/... paths and names
    path: '/v5',
    component: V5ShellRoute,
    meta: { auth: true },
    children: [...built.filter((r) => !r.meta.bare), ...placeholders],
  },
  ...built.filter((r) => r.meta.bare),
];
